import { createRouter } from "@tanstack/react-router";
import { ReactNode } from "react";
import { routeTree } from "routeTree.gen";
import { Permission } from "src/gql/graphql";

export const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    defaultStaleTime: 15 * 60 * 1000, // 15 minutes
    context: {
        auth: undefined!,
    },
});

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }

    interface StaticDataRouteOption {
        /** When set, exposes this route as searchable */
        spotlight?: {
            label: string;
            description: string;
            icon?: ReactNode;
            permissions?: Permission[];
            hideIf?: () => boolean;
        };
    }
}
